import { render, staticRenderFns } from "./riskAssessmentAllStatus.vue?vue&type=template&id=2040787a"
import script from "./riskAssessmentAllStatus.vue?vue&type=script&lang=js"
export * from "./riskAssessmentAllStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2040787a')) {
      api.createRecord('2040787a', component.options)
    } else {
      api.reload('2040787a', component.options)
    }
    module.hot.accept("./riskAssessmentAllStatus.vue?vue&type=template&id=2040787a", function () {
      api.rerender('2040787a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/status/riskAssessmentAllStatus.vue"
export default component.exports